import axios from './BaseService';

const AI_URL = `${process.env.REACT_APP_API_URL}/ai`;

const locale = () => localStorage.getItem('goldhub_locale') || 'en';

export async function getAnalysis(type = 'MARKET_SUMMARY', symbol = 'BNBUSDC', riskLevel = 'MODERATE') {
    const response = await axios.get(`${AI_URL}/analysis?type=${type}&symbol=${symbol}&riskLevel=${riskLevel}&locale=${locale()}`);
    return response.data;
}

export async function getRecommendation(symbol = 'BNBUSDC', riskLevel = 'MODERATE') {
    const response = await axios.get(`${AI_URL}/recommendation?symbol=${symbol}&riskLevel=${riskLevel}&locale=${locale()}`);
    return response.data;
}

export async function getAnalysisHistory(symbol = 'BNBUSDC', page = 1) {
    const response = await axios.get(`${AI_URL}/history?symbol=${symbol}&page=${page}`);
    return response.data;
}
